<template>
  <div>
    <!-- 标题 -->
    <div style="font-size:16px; color:#169BD5; padding: 6px;">
      <el-row>
        <el-col :span="10">
          已选资源
        </el-col>
        <el-col :span="14"
                style="text-align:right;">
          <el-button style="margin-bottom: 7px"
                     :loading="dataListLoading"
                     @click="closeDialog">取消</el-button>

          <el-button style="margin-bottom: 7px"
                     type="primary"
                     :loading="dataListLoading"
                     @click="sure">确定</el-button>
        </el-col>
      </el-row>
      <div :style="{ fontSize: '13px'}">
        <div style=" text-align: left; margin-top: 9px; padding: 7px 10px; ">
         <!-- <em class="el-icon-picture"></em>-->
          <img alt="" src="../../../assets/img/teacher.png" style="width: 18px">
          <span :style="{ color: '#000000'}">培训师&nbsp;&nbsp;</span>
          <span style=" color:#FFB017;">({{selectedResource.selectedTrainerListDTO.msg}})</span>
        </div>
        <div :style="{color: '#000000', padding: '5px'}"
             v-if="selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList.length > 0">
          <div :style="{color: '#000000', padding: '5px', background: tabName ==='trainer'?'#DDE9F9':'#F2F2F2'}">
            <div style="display: inline-block;">
              <el-popover trigger="click"
                          placement="top"
                          width="450"
                          v-for="(trainer, index) in selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList"
                          :key="index">
                <div>
                  <table v-if="trainer.trainerScheduleDTOList && trainer.trainerScheduleDTOList.length > 0" aria-describedby="">
                    <tr>
                      <td colspan="2">时间锁定明细:</td></tr>
                    <tr v-for="(trainerOne, index) in trainer.trainerScheduleDTOList"
                        :key="index">
                      <!-- <td>{{trainerOne.userName}}&nbsp;</td> -->
                      <td>{{trainerOne.scheduleDateS}}~{{trainerOne.scheduleDateE}}</td>
                    </tr>
                  </table>
                  <div v-if="!trainer.trainerScheduleDTOList || trainer.trainerScheduleDTOList.length === 0">
                     <span style="text-align:center !important;vertical-align:middle !important; color: #808080 !important;">&nbsp;时间锁定明细在保存资源之后显示&nbsp;</span>
                  </div>
                </div>
                <div slot="reference"
                     class="name-wrapper" style="padding-top: 10px">
                  <span class="rece_style_over" :title='trainer.userName' >{{trainer.userName}}</span>
                </div>
              </el-popover>
            </div>
            <div style="display: inline-block;">
              <div v-for="(trainer, index) in selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList"
                   :key="index" style="padding-top: 10px">
                <span class="other_style_over">
                  &nbsp{{trainer.dateS}}~{{trainer.dateE}}
                &nbsp;<strong style="cursor: pointer;" v-show="tabName ==='trainer'" @click="onTrainerDelete(trainer, index)">X</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  -->
      <div :style="{ fontSize: '13px'}">
        <div style=" text-align: left; margin-top: 9px; padding: 7px 10px; ">
          <!--<em class="el-icon-picture"></em>-->
          <img alt="" src="../../../assets/img/classroom.png" style="width: 18px">
          <span :style="{ color: '#000000'}">教室&nbsp;&nbsp;</span>
          <span style=" color:#FFB017;">({{selectedResource.selectedClassroomListDTO.msg}})</span>
        </div>
        <div :style="{color: '#000000', padding: '5px'}"
             v-if="selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.length > 0">
          <div :style="{color: '#000000', padding: '5px', background: tabName ==='classroom'?'#DDE9F9':'#F2F2F2'}">
            <div style="display: inline-block;">
              <el-popover trigger="click"
                          placement="top"
                          width="450"
                          v-for="(classRoom, index) in selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList"
                          :key="index">
                <div>
                  <table v-if="classRoom.classroomScheduleDTOList && classRoom.classroomScheduleDTOList.length > 0" aria-describedby="">
                    <tr>
                      <td colspan="2">时间锁定明细:</td></tr>
                    <tr v-for="(classOne, index) in classRoom.classroomScheduleDTOList"
                        :key="index">
                      <!-- <td>{{classOne.roomCnAbbr}}&nbsp;</td> -->
                      <td>{{classOne.scheduleDateS}}~{{classOne.scheduleDateE}}</td>
                    </tr>
                  </table>
                  <div v-if="!classRoom.classroomScheduleDTOList || classRoom.classroomScheduleDTOList.length === 0">
                     <span style="text-align:center !important;vertical-align:middle !important; color: #808080 !important;">&nbsp;时间锁定明细在保存资源之后显示&nbsp;</span>
                  </div>
                </div>
                <div slot="reference"
                     class="name-wrapper" style="padding-top: 10px">
                  <span class="rece_style_over" :title='classRoom.roomCnAbbr' >{{classRoom.roomCnAbbr}}</span>
                </div>
              </el-popover>
            </div>
            <div style="display: inline-block;">
              <div v-for="(classRoom, index) in selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList"
                   :key="index">
                <span class="other_style_over" style="padding-top: 10px">&nbsp;&nbsp;{{classRoom.dateS}}~{{classRoom.dateE}}
                &nbsp;&nbsp;<strong style="cursor: pointer;"  v-show="tabName ==='classroom'" @click="onClassRoomDelete(classRoom, index)">X</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  --  -->
      <div :style="{ fontSize: '13px'}">
        <div style=" text-align: left; margin-top: 9px; padding: 7px 10px; ">
          <!--<em class="el-icon-picture"></em>-->
          <img alt="" src="../../../assets/img/car.png" style="width: 18px">
          <span :style="{ color: '#000000'}">车辆&nbsp;&nbsp;</span>
          <span style=" color:#FFB017;">({{selectedResource.selectedVehicleListDTO.msg}})</span>
        </div>
        <div :style="{color: '#000000', padding: '5px'}"
             v-if="selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList.length > 0">
          <div :style="{color: '#000000', padding: '5px', background: tabName ==='vehicle'?'#DDE9F9':'#F2F2F2' }">
            <div style="display: inline-block;">
              <el-popover trigger="click"
                          placement="top"
                          width="450"
                          v-for="(vehicle, index) in selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList"
                          :key="index">
                <div>
                  <table v-if="vehicle.vehicleScheduleDTOList && vehicle.vehicleScheduleDTOList.length > 0" aria-describedby="">
                    <tr>
                      <td colspan="2">时间锁定明细:</td></tr>
                    <tr v-for="(vehicleOne, index) in vehicle.vehicleScheduleDTOList"
                        :key="index">
                      <!-- <td>{{vehicleOne.chassisNo}}&nbsp;</td> -->
                      <td>{{vehicleOne.scheduleDateS}}~{{vehicleOne.scheduleDateE}}</td>
                    </tr>
                  </table>
                  <div v-if="!vehicle.vehicleScheduleDTOList || vehicle.vehicleScheduleDTOList.length === 0">
                     <span style="text-align:center !important;vertical-align:middle !important; color: #808080 !important;">&nbsp;时间锁定明细在保存资源之后显示&nbsp;</span>
                  </div>
                </div>
                <div slot="reference"
                     class="name-wrapper" style="padding-top: 10px">
                  <span class="rece_style_over" :title='vehicle.chassisNo' >{{vehicle.chassisNo}}</span>
                </div>
              </el-popover>
            </div>
            <div style="display: inline-block;">
              <div v-for="(vehicle, index) in selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList"
                   :key="index">
                <span class="other_style_over" style="padding-top: 10px">&nbsp;&nbsp;{{vehicle.dateS}}~{{vehicle.dateE}}
                  &nbsp;&nbsp;<strong style="cursor: pointer;" v-show="tabName ==='vehicle'" @click="onVehicleDelete(vehicle, index)">X</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selectedResources',
  props: {
    // 主页切换内容
    tabName: String,
    // 传入参数
    afferentParam: {
      type: Object
    }
  },
  data () {
    return {
      selectedResource: {
        selectedClassroomListDTO: {
          msg: '', selectedClassroomItemDTOList: []
        },
        selectedTrainerListDTO: {
          msg: '', selectedTrainerItemDTOList: []
        },
        selectedVehicleListDTO: {
          msg: '', selectedVehicleItemDTOList: []
        }
      },
      dataListLoading: false
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  /* mounted () {
    this.$eventHub.$on('initMethod', data => {
      this.initMethod()
    })
  }, */
  methods: {
    // 删除培训师
    onTrainerDelete (item, index) {
      // this.$confirm('您确定删除【' + item.userName + '】这条数据吗?', '提示', {
      this.$confirm('您确定移除这条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // debugger
        this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
      this.$forceUpdate(); // 刷新页面视图
    },
    // 删除教室
    onClassRoomDelete (item, index) {
      this.$confirm('您确定删除这条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    // 删除车辆
    onVehicleDelete (item, index) {
      this.$confirm('您确定删除这条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    // 关闭dialig
    closeDialog () {
      // 通知最外层父组件关闭dialog
      this.$emit('closeResDialog', '')
      // this.$eventHub.$emit('close_parent_dialog', '')
    },
    // 确定
    sure () {
      // console.log(JSON.stringify(this.selectedResource))
      this.$emit('resourceBack', this.selectedResource)
    },
    // 选择教室方法
    selectClassroome (msg) {
      console.log(msg, 'dddddsdsdsdsd')
      if (this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.length > 0) {
        for (let i = 0; i < this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.length; i++) {
          console.log(i)
          if (this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList[i].siteCnName === '腾讯会议' && msg.siteCnName === '腾讯会议') {
            this.$message({
              message: '只能选择一个腾讯会议室，如需重新选择，请先删除已选会议室!',
              type: 'error',
              duration: 2000
            })
            return
          }
          console.log(i)
        }
      }
      let selectId = ''
      let rowId = ''
      if (msg) {
        selectId = msg.classroomId
        let flag = true
        for (let i = 0; i < this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.length; i++) {
          rowId = this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList[i].classroomId
          if (this.checkSelectKey(selectId, rowId) === true) {
            if (this.checkSelectObj(msg, this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList[i]) === false) {
              flag = false
            }
          }
        }
        if (flag) {
          msg.dateS = msg.dateS.substr(0, 16)
          msg.dateE = msg.dateE.substr(0, 16)
          this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList.push(msg)
        } else {
          this.$message({
            message: '该时间区间已选择!',
            type: 'error',
            duration: 2000
          })
        }
        console.log(this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList, 'ddddddd')
      }
    },
    // 选择培训师方法
    selectTrainer (msg) {
      this.$forceUpdate(); // 刷新页面视图
      console.info(this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList)
      // debugger
      let selectId = ''
      let rowId = ''
      if (msg) {
        selectId = msg.trainerId
        let flag = true
        for (let i = 0; i < this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList.length; i++) {
          rowId = this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList[i].trainerId
          if (this.checkSelectKey(selectId, rowId) === true) {
            if (this.checkSelectObj(msg, this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList[i]) === false) {
              flag = false
            }
          }
        }
        if (flag) {
          msg.dateS = msg.dateS.substr(0, 16)
          msg.dateE = msg.dateE.substr(0, 16)
          this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList.push(msg)
        } else {
          // debugger
          this.$message({
            message: '该时间区间已选择!',
            type: 'error',
            duration: 2000
          })
        }
      }
    },
    // 选择车辆方法
    selectVehicle (msg) {
      let selectId = ''
      let rowId = ''
      if (msg) {
        selectId = msg.vehicleId
        let flag = true
        for (let i = 0; i < this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList.length; i++) {
          rowId = this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList[i].vehicleId
          if (this.checkSelectKey(selectId, rowId) === true) {
            if (this.checkSelectObj(msg, this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList[i]) === false) {
              flag = false
            }
          }
        }
        if (flag) {
          msg.dateS = msg.dateS.substr(0, 16)
          msg.dateE = msg.dateE.substr(0, 16)
          this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList.push(msg)
        } else {
          this.$message({
            message: '该时间区间已选择!',
            type: 'error',
            duration: 2000
          })
        }
      }
    },
    checkSelectKey (select, row) {
      // 不同的对象来源导致类型不同，判断前处理下
      if ('' + select === '' + row) {
        return true
      } else {
        return false
      }
    },
    checkSelectObj (select, row) {
      if (new Date(select.dateS) >= new Date(row.dateS) && new Date(select.dateS) <= new Date(row.dateE)) {
        return false
      } else if (new Date(select.dateE) >= new Date(row.dateS) && new Date(select.dateE) <= new Date(row.dateE)) {
        return false
      } else if (new Date(select.dateS) <= new Date(row.dateS) && new Date(select.dateE) >= new Date(row.dateE)) {
        return false
      } else {
        return true
      }
    },
    //
    initMethod () {
      this.$eventHub.$emit('close_add_disable', true)
      this.dataListLoading = true
      this.$forceUpdate(); // 刷新页面视图
      this.selectedResource.selectedClassroomListDTO.selectedClassroomItemDTOList = []
      this.selectedResource.selectedClassroomListDTO.msg = ''
      this.selectedResource.selectedTrainerListDTO.selectedTrainerItemDTOList = []
      this.selectedResource.selectedTrainerListDTO.msg = ''
      this.selectedResource.selectedVehicleListDTO.selectedVehicleItemDTOList = []
      this.selectedResource.selectedVehicleListDTO.msg = ''
      if (this.afferentParam) {
        let url = '/rm/schedule/queryResourceScheduleDetail'
        let param = {
          'sessionId': this.afferentParam.sessionId,
          'courseId': this.afferentParam.courseId,
          'siteId': this.afferentParam.siteId,
          'selectedClassroomListDTO': this.afferentParam.selectedResource.selectedClassroomListDTO,
          'selectedTrainerListDTO': this.afferentParam.selectedResource.selectedTrainerListDTO,
          'selectedVehicleListDTO': this.afferentParam.selectedResource.selectedVehicleListDTO
        }
        this.$request.post(
          url, param
        ).then((res, total, code, data) => {
          if (data.data.selectedClassroomListDTO.selectedClassroomItemDTOList !== [] && data.data.selectedClassroomListDTO.selectedClassroomItemDTOList !== undefined && data.data.selectedClassroomListDTO.selectedClassroomItemDTOList.length !== 0) {
            for (let i = 0; i < data.data.selectedClassroomListDTO.selectedClassroomItemDTOList.length; i++) {
              data.data.selectedClassroomListDTO.selectedClassroomItemDTOList[i].dateS = data.data.selectedClassroomListDTO.selectedClassroomItemDTOList[i].dateS.substr(0, 16)
              data.data.selectedClassroomListDTO.selectedClassroomItemDTOList[i].dateE = data.data.selectedClassroomListDTO.selectedClassroomItemDTOList[i].dateE.substr(0, 16)
            }
          }
          if (data.data.selectedTrainerListDTO.selectedTrainerItemDTOList !== [] && data.data.selectedTrainerListDTO.selectedTrainerItemDTOList.length !== 0) {
            for (let j = 0; j < data.data.selectedTrainerListDTO.selectedTrainerItemDTOList.length; j++) {
              data.data.selectedTrainerListDTO.selectedTrainerItemDTOList[j].dateS = data.data.selectedTrainerListDTO.selectedTrainerItemDTOList[j].dateS.substr(0, 16)
              data.data.selectedTrainerListDTO.selectedTrainerItemDTOList[j].dateE = data.data.selectedTrainerListDTO.selectedTrainerItemDTOList[j].dateE.substr(0, 16)
            }
          }
          if (data.data.selectedVehicleListDTO.selectedVehicleItemDTOList !== [] && data.data.selectedVehicleListDTO.selectedVehicleItemDTOList !== undefined && data.data.selectedVehicleListDTO.selectedVehicleItemDTOList.length !== 0) {
            for (let h = 0; h < data.data.selectedVehicleListDTO.selectedVehicleItemDTOList.length; h++) {
              data.data.selectedVehicleListDTO.selectedVehicleItemDTOList[h].dateS = data.data.selectedVehicleListDTO.selectedVehicleItemDTOList[h].dateS.substr(0, 16)
              data.data.selectedVehicleListDTO.selectedVehicleItemDTOList[h].dateE = data.data.selectedVehicleListDTO.selectedVehicleItemDTOList[h].dateE.substr(0, 16)
            }
          }
          this.selectedResource = data.data
          this.dataListLoading = false
          // 关闭添加按钮禁用
          this.$eventHub.$emit('close_add_disable', false)
          console.info('this.selectedResource------->打印', this.selectedResource)
          this.$forceUpdate(); // 刷新页面视图
        }).catch(() => {
          this.dataListLoading = false
          // 关闭添加按钮禁用
          this.$eventHub.$emit('close_add_disable', false)
        })
      } else {
        this.dataListLoading = false
        // 关闭添加按钮禁用
        this.$eventHub.$emit('close_add_disable', false)
      }
    }
  },
  // 监听通知
  mounted () {
    this.$nextTick(() => {
      this.initMethod('创建子组件执行了')
    })
  },
  created () {
    this.$eventHub.$on('select_classroom_wxl', (data) => {
      this.selectClassroome(data)
    })
    this.$eventHub.$on('select_trainer_wxl', (data) => {
      // debugger
      this.selectTrainer(data)
    })
    this.$eventHub.$on('select_vehicle_wxl', (data) => {
      this.selectVehicle(data)
    })
  },
  beforeDestroy  () {
    this.$eventHub.$off('select_classroom_wxl')
    this.$eventHub.$off('select_trainer_wxl')
    this.$eventHub.$off('select_vehicle_wxl')
  }
}
</script>
<style>
#scrollbar11,
#scrollbar11 > .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>
<style scoped>
#scrollbar11 {
  height: 100%;
  width: 100%;
}
.rece_style_over {
  display:block;/*内联对象需k加*/
  width:110px;
  word-break:keep-all;/* 不换行 */
  white-space:nowrap;/* 不换行 */
  overflow:hidden;/* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}
.other_style_over {
  display:block;/*内联对象需加*/
  width:260px;
  word-break:keep-all;/* 不换行 */
  white-space:nowrap;/* 不换行 */
  overflow:hidden;/* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}
  .other_style_over_div {
    margin-bottom: 7px;
  }
</style>
